import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import ProfGralSpacGrid from '../component/ProfGralSpacGrid';
const profGralSpacPage = () => {
  return (
    <>
      <h2 className={'TitleGrid'}>
        <Trans>Profile General Spac</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <ProfGralSpacGrid />
    </>
  );
};

export default profGralSpacPage;
